/** Shared agent subject labels/icons for admin list tables. */

export const AGENT_SUBJECT_LABELS: Record<string, string> = {
    brief: 'Built-to-Brief',
    built_to_brief: 'Built-to-Brief',
    assessment: 'Illuminator',
    illuminator: 'Illuminator',
    gapfinder: 'GapFinder',
};

export const AGENT_SUBJECT_ICONS: Record<string, string> = {
    brief: 'pencil alternate',
    built_to_brief: 'pencil alternate',
    assessment: 'lightbulb',
    illuminator: 'lightbulb',
    gapfinder: 'search',
};

/** Map brief_type / subject_type to data-subject accent key. */
export function agentSubjectKey(type: string): string {
    if (type === 'built_to_brief') return 'brief';
    if (type === 'illuminator') return 'assessment';
    return type;
}

export function getAgentSubjectLabel(type: string): string {
    return AGENT_SUBJECT_LABELS[type] ?? type;
}

export function getAgentSubjectIcon(type: string): string {
    const key = agentSubjectKey(type);
    return AGENT_SUBJECT_ICONS[key] ?? AGENT_SUBJECT_ICONS[type] ?? 'cog';
}
